exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slot[data-v-43bd4ce0]{border-top:1px solid #f7f7f7}.slot.success[data-v-43bd4ce0]{background-color:#25b372!important;border:2px solid #25b372!important}.slot.selected[data-v-43bd4ce0]{background-color:#25b372!important;border:2px solid #0a6a3e!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43bd4ce0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/procedure/procedure-viewing-elements/element-view-booking.vue
// module id = 1359
// module chunks = 0